import React from 'react';

const CustomEventLeaderboardNameColumn = ({ options, player }) => {
    return (
        <div className={'custom-event-leaderboard__team-name'}>
            {
                player !== undefined && player !== null &&
                <div className={'live-player-hero__title'}>
                    {
                        options.isTeamEvent &&
                            <span className={'live-player-hero__firstname'}>{options.teamLabel}</span>
                    }
                    <span className={'live-player-hero__lastname'}>{player.name}</span>
                </div>
            }
        </div>
    );
};

export default CustomEventLeaderboardNameColumn;
